var map = {
	"./backgrounds/outside/endgame.svg": 3277,
	"./backgrounds/outside/grill-blazing.svg": 6221,
	"./backgrounds/outside/grill-fired.svg": 1712,
	"./backgrounds/outside/grill-off.svg": 1087,
	"./backgrounds/outside/grill-on.svg": 26,
	"./backgrounds/outside/outside.svg": 3552,
	"./bird.svg": 7191,
	"./characters/manager-burned.svg": 4662,
	"./characters/manager.svg": 8090,
	"./characters/seagull.svg": 356,
	"./dev/icon-menu.svg": 8055,
	"./endGame-smoke.svg": 3822,
	"./grill-title.svg": 7803,
	"./icons/icon-arrow-2.svg": 3650,
	"./icons/icon-arrow-down.svg": 2337,
	"./icons/icon-arrow-right.svg": 9352,
	"./icons/icon-arrow.svg": 941,
	"./icons/icon-audio-pause-blue.svg": 5173,
	"./icons/icon-audio-pause.svg": 456,
	"./icons/icon-audio-play-blue.svg": 9076,
	"./icons/icon-audio-play.svg": 9895,
	"./icons/icon-checkmark.svg": 4288,
	"./icons/icon-cookies.svg": 9899,
	"./icons/icon-correct.svg": 6145,
	"./icons/icon-cross-white.svg": 4316,
	"./icons/icon-cross.svg": 1146,
	"./icons/icon-drag.svg": 6123,
	"./icons/icon-home.svg": 6750,
	"./icons/icon-language.svg": 6717,
	"./icons/icon-loading-white.svg": 7177,
	"./icons/icon-loading.svg": 2854,
	"./icons/icon-lock.svg": 2040,
	"./icons/icon-logout-2.svg": 9657,
	"./icons/icon-logout.svg": 655,
	"./icons/icon-next.svg": 5732,
	"./icons/icon-retry.svg": 1543,
	"./icons/icon-sort-asc.svg": 9528,
	"./icons/icon-sort-desc.svg": 5331,
	"./icons/icon-star-filled.svg": 3463,
	"./icons/icon-star.svg": 9832,
	"./icons/icon-wrong.svg": 3003,
	"./languages/da.svg": 2318,
	"./languages/en.svg": 6391,
	"./logo-cgl.svg": 6839,
	"./logo-tican.svg": 2000,
	"./modules - Shortcut.lnk": 5755,
	"./modules/tasks/multiple-choice/s1-m1-grill-clothing/option-1.svg": 6070,
	"./modules/tasks/multiple-choice/s1-m1-grill-clothing/option-2.svg": 4059,
	"./modules/tasks/multiple-choice/s1-m1-grill-clothing/option-3.svg": 1337,
	"./modules/tasks/multiple-choice/s1-m1-grill-clothing/option-4.svg": 3482,
	"./modules/tasks/multiple-choice/s1-m1-handwashing/background.svg": 2692,
	"./modules/tasks/multiple-choice/s1-m1-lighting-fuel/option-1.svg": 4279,
	"./modules/tasks/multiple-choice/s1-m1-lighting-fuel/option-2.svg": 11,
	"./modules/tasks/multiple-choice/s1-m1-lighting-fuel/option-3.svg": 3414,
	"./modules/tasks/multiple-choice/s1-m1-lighting-fuel/option-4.svg": 4998,
	"./modules/tasks/multiple-choice/s1-m1-lighting-fuel/option-5.svg": 8559,
	"./modules/tasks/multiple-choice/s1-m1-lighting-fuel/option-6.svg": 5999,
	"./modules/tasks/organize/s1-m2-grilling-amount/background.svg": 1751,
	"./modules/tasks/organize/s1-m2-grilling-amount/beef-medium.svg": 9700,
	"./modules/tasks/organize/s1-m2-grilling-amount/beef-raw.svg": 6982,
	"./modules/tasks/organize/s1-m2-grilling-amount/beef-welldone.svg": 7018,
	"./modules/tasks/organize/s1-m2-grilling-amount/carton-medium.svg": 1313,
	"./modules/tasks/organize/s1-m2-grilling-amount/carton-raw.svg": 6387,
	"./modules/tasks/organize/s1-m2-grilling-amount/carton-welldone.svg": 4273,
	"./modules/tasks/organize/s1-m2-grilling-amount/chicken-medium.svg": 3674,
	"./modules/tasks/organize/s1-m2-grilling-amount/chicken-raw.svg": 4069,
	"./modules/tasks/organize/s1-m2-grilling-amount/chicken-welldone.svg": 6556,
	"./modules/tasks/organize/s1-m2-grilling-amount/mince-medium.svg": 5320,
	"./modules/tasks/organize/s1-m2-grilling-amount/mince-raw.svg": 3861,
	"./modules/tasks/organize/s1-m2-grilling-amount/mince-welldone.svg": 1651,
	"./modules/tasks/organize/s1-m2-grilling-amount/sausage-medium.svg": 6827,
	"./modules/tasks/organize/s1-m2-grilling-amount/sausage-raw.svg": 1300,
	"./modules/tasks/organize/s1-m2-grilling-amount/sausage-welldone.svg": 600,
	"./modules/tasks/organize/s1-m2-grilling-amount/squash-medium.svg": 2500,
	"./modules/tasks/organize/s1-m2-grilling-amount/squash-raw.svg": 8034,
	"./modules/tasks/organize/s1-m2-grilling-amount/squash-welldone.svg": 6169,
	"./modules/tasks/spot-errors/s1-m2-grill-hygiene/background.svg": 7721,
	"./startGame-grill-smoke.svg": 4859
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;